import { render, staticRenderFns } from "./expand-collapse-messages.vue?vue&type=template&id=6e6f982a&"
import script from "./expand-collapse-messages.vue?vue&type=script&lang=js&"
export * from "./expand-collapse-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports